import type { TranscriptSpeakerPayload } from '@Application/Beneficiaries/Transcripts/Actions/transcriptSpeakersFetched';

export type TranscriptSpeakersMergedAction = {
	type: 'TRANSCRIPT_SPEAKERS_MERGED';
	// The response carries only the target speaker (§5.6b); the source id is never echoed back, so it
	// travels alongside the payload from the command that triggered the merge.
	payload: TranscriptSpeakerPayload;
	interviewId: number;
	sourceSpeakerId: number;
};

export default (
	payload: TranscriptSpeakerPayload,
	interviewId: number,
	sourceSpeakerId: number,
): TranscriptSpeakersMergedAction => ({
	type: 'TRANSCRIPT_SPEAKERS_MERGED',
	payload,
	interviewId,
	sourceSpeakerId,
});
